/**
 * App Light Theme
 */
import { createTheme } from '@mui/material/styles';
import AppConfig from 'Constants/AppConfig';
import { appTypography } from './typography';

const theme = createTheme({
	palette: {
		primary: {
			main: AppConfig.themeColors.primary
		},
		secondary: {
			main: AppConfig.themeColors.warning
		}
	},
	typography: appTypography,
});

export default theme;
